/*Add Business Insights(BI), Debriefs(DB) to projects Jan 25, 2022 */
/* Add prefences   Mar 13, 2022 */
/* Add roles, Staff Management to Team Member Nav  Oct 30, 2022  */
/* Add PS to oppor Entity   Dec 15, 2022 */
/* Add Proposal Templates Jan 8, 2023 */
/* Replace "External Contacts" with "Contacts" Jan 21, 2023 */
/* Add OT View for OpportunityTeam Dec 30, 2023 */
/* Add Construction Scopes Dec 30, 2023 */
/* Add ratingsRF data Dec 30, 2023 */
/* Add fn_checkPageEnabled,Help links, Address Book  Apr 13,2024 */
/* Add Complete Proposal CPS June 29, 2026 */
import {fn_getReferenceData, fn_getAppTenantSettings, fn_getAppUserSettings, fn_getUserReminders} from "@/utils/api.js";
import {api_baseURL, lcl_userInfo} from "@/utils/init.js";
import {fn_checkPageEnabled} from "@/utils/util.js";



const const_refData = {
   businessInsightProps: [],
   projectBusinessInsightProps: [],
   dashboards: [],
   decisionStatuses: [],
   opportunityStatuses: [],
   opportunityTypes: [],
   projectStatuses: [],
   taskStatuses: [],

   accountTypes: [],
   contractTypes: [],
   debriefQuestions: [],
   decisionQuestions: [],
   leadSources: [],
   categories: [],
   marketSegments: [],
   opportunitySubStatuses: [],
   ownerTypes: [],
   salesGoalsNoteCategories: [],
   taskTypes: [],
   taskTemplates: [],
   preferences: [],
   roles:[],
   proposalTemplates:[],

   taskPriorities: [
      {value: null, text: ""},
      {value: 5, text: "￪ Critical"}, //↟
      {value: 4, text: "⇡ High"},
      {value: 3, text: "• Medium"},
      {value: 2, text: "⇣ Low"},
      {value: 1, text: "￬ Idle"} //↡
   ],
   probabilities: [
      {value: null, text: ""},
      {value: 20, text: "20%"},
      {value: 40, text: "40%"},
      {value: 60, text: "60%"},
      {value: 80, text: "80%"},
      {value: 100, text: "100%"},
   ],
   decisionWeights: [0, .1, .2, .3, .4, .5, .6, .7, .8, .9, 1].map(x => ({value: x, text: x})),
   
   preferenceNames:[ {value:"calendarPreference", 
                     text: "Calendar Preference"
					},
					{value:"calendarTenantId", 
						text: "Calendar Provider TenantId"
					}
				],

	preferenceValues: [
				{
					key: "calendarPreference",
					values: [
					{value:"Outlook", text:"Outlook"},
					{value:"Gmail",text:"Gmail"}
					]
				}
 
			],
   

   months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
   selOpt: (refData, currId) => {

      let opts = refData.filter(x => !x.disabled || x.id == currId);
      return [{id: null, name: ''}, ...opts];
   },
   taskStatus: (id, name) => {
      return const_refData.taskStatuses.filter(x => x.id == id || x.name == name)[0] || {};
   }
};
const const_tenantSettings = {
   general: {},
   decisionOptions: {},
};
const const_userSettings = {
   permissions: {},
   userOptions: {},
};
const const_userReminders = {
   reminders: [],
   refData: {oppr: [], proj: [], acct: []},
   lastCheck: null,
   rmdCnt: 0,
   fn_reCheck: (bfrMin) => {
      let ur = const_userReminders;
      if ((Date.now() - ur.lastCheck) / 1000 / 60 < bfrMin) return;

      fn_getUserReminders().then(resp => {
         ur.lastCheck = Date.now();
         let rr = resp.reminders || [];
         rr.forEach(x => x.daysB4 = x.dismissed = null);
         ur.rmdCnt = rr.length;
         ur.reminders.length = 0;
         ur.reminders.push(...rr);
         if (resp.refData) {
            Object.keys(ur.refData).forEach(k => {
               ur.refData[k] = resp.refData[k] || [];
            });
         }

      });
   }
};
const const_teamAnnouncements = {
   announcements: [],
   lastCheck: null,
   fn_reCheck: (bfrMin) => {
      let ta = const_teamAnnouncements;
      if ((Date.now() - ta.lastCheck) / 1000 / 60 < bfrMin) return;

      let CatProp = 'teamAnnouncements';
      fn_getAppTenantSettings(CatProp, CatProp).then(resp => {
         ta.lastCheck = Date.now();
         let annc = resp.value || [];

         ta.announcements.length = 0;
         ta.announcements.push(...annc);

      });
   }
};

//Client
const const_appEntities = [
   {
      key: 'oppr',
      name: 'opportunity',
      Name: 'Opportunity',
      label: 'Opportunities',
      description: '',
      icon: 'tablet-alt',
      idKey: 'opportunityId',
      numKey: 'opportunityNo',
      nameKey: 'opportunityName',
      color: '#0074f0',
      subEnt: [
         {
            key: 'oppr-activities',
            name: 'opportunityTask',
            label: 'Activities',
            prntLabel: 'Opportunity',
            hidden: false,
            hiddenFn: () => {return !fn_checkPageEnabled('Opportunity Activities');}
         }
      ],
		hidden: false,
		hiddenFn: () => {return !fn_checkPageEnabled('Opportunities');},
      altView: ['TASK', 'AT', 'DECS', 'BI', 'DB', 'PS','CPS','OT','AM'],
      importRecComp: () => import("@/components/Rec/OpprRec.vue"),
      importNavComp: () => import("@/components/Nav/OpprNav.vue"),
   },
   {
      key: 'proj',
      name: 'project',
      Name: 'Project',
      label: 'Projects',
      description: '',
      icon: 'trophy',
      idKey: 'projectId',
      numKey: 'projectNo',
      nameKey: 'projectName',
      color: '#4cc24a',
      subEnt: [
         {
            key: 'proj-activities',
            name: 'projectTask',
            label: 'Activities',
            prntLabel: 'Project',
            hidden: false,
            hiddenFn: () => {return !fn_checkPageEnabled('Project Activities');},
         },
      ],
		hidden: false,
		hiddenFn: () => {return !fn_checkPageEnabled('Projects');},
      altView: ['TASK', 'AT', 'BI', 'DB'],
      importRecComp: () => import("@/components/Rec/ProjRec.vue"),
      importNavComp: () => import("@/components/Nav/ProjNav.vue"),
   },
   {
      key: 'acct',
      name: 'account',
      Name: 'Account',
      label: 'Accounts',
      description: '',
      icon: 'money-check',
      idKey: 'accountId',
      numKey: 'accountNo',
      nameKey: 'accountName',
      color: '#c7a29d',
      subEnt: [
         {
            key: 'acct-activities',
            name: 'accountTask',
            label: 'Activities',
            prntLabel: 'Account',
            hidden: false,
            hiddenFn: () => {return !fn_checkPageEnabled('Account Activities');},
         }
      ],
		hidden: false,
		hiddenFn: () => {return !fn_checkPageEnabled('Accounts');},
      altView: ['TASK', 'AT', 'RR'],
      importRecComp: () => import("@/components/Rec/AcctRec.vue"),
      importNavComp: () => import("@/components/Nav/AcctNav.vue"),
   },
   {
      key: 'cmpt',
      name: 'competitor',
      Name: 'Competitor',
      label: 'Competitors',
      description: '',
      icon: 'building',
      idKey: 'competitorId',
      numKey: 'competitorNo',
      nameKey: 'competitorName',
      color: '#b3a8ff',
      hidden: false,
      hiddenFn: () => {return !fn_checkPageEnabled('Competitors');},
      altView: ['RR'],
      importRecComp: () => import("@/components/Rec/CmptRec.vue"),
      importNavComp: () => import("@/components/Nav/CmptNav.vue"),
   },
   {
      key: 'extr',
      name: 'contact',
      Name: 'Contact',
      label: 'Contacts',
      description: '',
      icon: 'address-card',
      idKey: 'externalContactId',
      numKey: 'externalContactNo',
      nameKey: 'externalContactName',
      color: '#9fc1cc',
      hidden: false,
      hiddenFn: () => {return !fn_checkPageEnabled('Contacts');},
      altView: ['RR'],
      importRecComp: () => import("@/components/Rec/ExtrRec.vue"),
      importNavComp: () => import("@/components/Nav/ExtrNav.vue"),
   },
   {
      key: 'team',
      name: 'teamMember',
      Name: 'Team Member',
      label: 'Team Members',
      description: '',
      icon: 'user-friends',
      idKey: 'teamMemberId',
      numKey: 'teamMemberNo',
      nameKey: 'teamMemberName',
      color: '#ffb357',
		subEnt:  [ {
					key: 'staff',
					name: 'staffing',
					label: 'Staffing Management',
					prntLabel: '',
					hidden: false,
					hiddenFn: () => {return false;},
				}
		],
      hidden: false,
		hiddenFn: () => {return !fn_checkPageEnabled('Team Members');},
      altView: ['RR'],
      importRecComp: () => import("@/components/Rec/TeamRec.vue"),
      importNavComp: () => import("@/components/Nav/TeamNav.vue"),
   },
   {
      key: 'task',
      label: 'Activities',
      importNavComp: () => import("@/components/Nav/TaskNav.vue"),
   },
   {
      key: 'cal',
      name: 'calendar',
      Name: 'Calendar',
   },
    {
		key:'constructionscope',
		name:'constructionScope',
		Name:'Construction Scope',
		label:'Construction Scope',
		idKey: 'constructionScopeId',
		numKey: 'constructionScopeNo',
		nameKey: 'constructionScopeName',
		icon: 'building',
		color:'red',
		hidden: true,
   },
   {
	key: 'addr',
	name: 'addressBook',
	label: 'Address Book',
	prntLabel: '',
	icon:'address-book',
	color:'#ffa500',
	hidden: false,
	hiddenFn: () => {return !(fn_checkPageEnabled('Address Book'));}, //fn_checkPageEnabled('Contacts','Address Book')
	}
];
const const_defaults = {
   taskStatusId: () => {return const_refData.taskStatus(null, "To Do").id;}
};

const ratingsRF=[{ id: 0, rating: 0, riskFactor: "unknown", html:'<span style="background-color:yellow;color:black;">unknown</span>' },
				{ id: 1, rating: 1, riskFactor: "high", html:'<span style="background-color:red;color:white;">high</span>' },
				{ id: 2, rating: 2, riskFactor: "high", html:'<span style="background-color:red;color:white;">high</span>' },
				{ id: 3, rating: 3, riskFactor: "medium", html:'<span style="background-color:blue;color:white;">medium</span>' },
				{ id: 4, rating: 4, riskFactor: "medium",html:'<span style="background-color:blue;color:white;">medium</span>' },
				{ id: 5, rating: 5, riskFactor: "low",html:'<span style="background-color:green;color:white;">low</span>' }
				];
const	Help=[
		{title:"Application Tutorial",URL:"https://www.kiesetechnologies.com/help-tutorial-videos-and-documents/",active:true},
		{html:'<sup style="color:green;"><b>New</b></sup>',title:"Personalize your Home Page",URL:"https://www.kiesetechnologies.com/help-tutorial-videos-and-documents/",active:true}
	];

export {
   api_baseURL,
   const_appEntities as appEntities,
   const_refData as refData,
   const_tenantSettings as tenantSettings,
   const_userSettings as userSettings,
   const_userReminders as userReminders,
   const_teamAnnouncements as teamAnnouncements,
   lcl_userInfo as userInfo,
   const_defaults as defaults,
   fn_appEnt,
   fn_loadRTU,
   ratingsRF,
   Help,
};

function fn_appEnt(key, prntKey) {
   if (key == 'all') {
      return {
         key: 'all',
         name: 'allRecords',
         label: 'All Records ',
         icon: 'database',
         idKey: 'recordId',
         numKey: 'recordNo',
         nameKey: 'recordName',
         color: '#4fa4ff',
      };
   }
   else if (key == 'task') {
      let aet = const_appEntities.filter(x => x.key == key)[0];
      if (!prntKey) return aet;
      let aep = const_appEntities.filter(x => x.key == prntKey)[0];
      return {
         key,
         name: aep.name + 'Task',
         Name: aep.Name + ' Activity',
         label: aep.Name + ' Activities',
         idKey: aep.name + 'TaskId'
      };

   }
   else {
      return const_appEntities.filter(x => x.key == key)[0];
   }
}

async function fn_loadRTU() {
   //Called only from router.js on dynamic import
   let rd = fn_getReferenceData().then(resp => {
      Object.keys(resp).forEach(k => {
         const_refData[k] = resp[k];
      });
   });

   let ats = fn_getAppTenantSettings().then(resp => {
      let ts = const_tenantSettings;

      ts.general = resp.general || {};
      ts.decisionOptions = resp.decisionOptions || {};
   });

   let aus = fn_getAppUserSettings().then(resp => {
      const_userSettings.permissions = fn_boolParser(resp.permissions);
      const_userSettings.userOptions = fn_boolParser(resp.userOptions);
	  console.log('In ref-data fn_getAppUserSettings');
	  console.log(resp);
      function fn_boolParser(obj) {
         if (!obj) return {};
         Object.keys(obj).forEach(k => {obj[k] = obj[k] === 'true' ? true : obj[k] === 'false' ? false : obj[k];});
         return obj;
      }
   });

   return Promise.all([rd, ats, aus]);
}